import { CircularProgress } from '@material-ui/core';
import { ThreeBounce } from 'better-react-spinkit';
import React from 'react';
import { styled } from '~ui-kit/styled-components';
import { Box } from './box.component';
import { Text } from './text.component';

interface LoadingPropsProps {
  text?: string;
  children?: React.ReactNode;
}

/**
 * @deprecated Use ~ui-kit/components/loading-spinner
 */
export function DataLoading({ text, children }: LoadingPropsProps) {
  return (
    <Box align="center" justify="center" flexDirection="column" width={['100%']} className="loader">
      <Loader size={24} />
      {text && <LoadingText>{text}</LoadingText>}
      {children}
    </Box>
  );
}

export function CircularProgressLoading({ text, children }: LoadingPropsProps) {
  return (
    <Box align="center" justify="center" flexDirection="column" width={['100%']}>
      <CircularProgressLoader size={24} />
      {text && <LoadingText>{text}</LoadingText>}
      {children}
    </Box>
  );
}

const LoadingText = styled(Text).attrs({ py: [3], fontSize: [4], fontWeight: 500, color: 'primaryLight' })``;

const Loader = styled(ThreeBounce)`
  & > div {
    background-color: ${(props) => props.theme.colors.primary} !important;
  }
`;

const CircularProgressLoader = styled(CircularProgress)`
  & > div {
    background-color: ${(props) => props.theme.colors.primary} !important;
  }
`;
